import styled from 'styled-components';
import {theme} from './../../../styles/theme'

export const TitleWrapper = styled.h1`
  margin: 25px 65px;
  font-family: "MySatisfy", Sans-serif;
  font-size: 72px;
  width: 75vw;

  font-weight: 400;
  font-style: normal;
  color: ${({ theme }) => theme.colors.primary};
  display: flex;
  padding: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    font-size: 72px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.miniNotebbok}) {
    font-size: 72px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.ipadBig}) {
    font-size: 60px;
    margin: 5px 15px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.ipadMedium}) {
    font-size: 45px;
    margin: 5px 15px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.ipadMini}) {
    font-size: 45px;
    margin: 5px 15px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobileBig}) {
    font-size: 40px;
    margin: 5px 15px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobileMedium}) {
    font-size: 35px;
    margin: 5px 15px;
    width: 295px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobileMini}) {
    font-size: 35px;
    margin: 5px 3px;
    width: 295px;
  }

`